export default "__VITE_ASSET__RCKBPceM__"